import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CostDetailsComponent} from './cost-details.component';
import {RouterModule} from '@angular/router';
import {SharedModule} from 'src/app/shared/shared.module';
import {MatDividerModule} from '@angular/material/divider';
import {SearchFilterModule} from 'src/app/components/search-filter/search-filter.module';
import {DropdownFilterModule} from 'src/app/components/dropdown-fliter/dropdown-filter.module';
import {CostDetailsRoutingModule} from './cost-details-routing.module';

@NgModule({
  declarations: [
    CostDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule, MatDividerModule, SearchFilterModule, DropdownFilterModule, CostDetailsRoutingModule,
  ]
})
export class CostDetailsModule {
}
